import request from "@/config/utils/request";

export function getInquirySummary(data) {
  return request({
    url: "/apis/demo/template/listInquirySummary",
    method: "post",
    data
  });
}
